import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OpenStatusComponent } from './open-status.shared.component';

@NgModule({
    declarations: [
        OpenStatusComponent
    ],
    imports: [CommonModule],
    exports: [
        OpenStatusComponent
    ],
    providers: [],
})
export class OpenStatusModule { }
